import {tempo} from '@tempo/core';
import type {ComponentProps} from 'react';

export const Svg = tempo('svg');
export type SvgProps = ComponentProps<typeof Svg>;
